module.exports = __webpack_public_path__ + "img/NY.961f27e7.png";